import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AlertV2 as Alert, Button, Modal } from '@feathr/components';
import { EAlertType } from '@feathr/components/src/AlertV2/AlertV2';

interface IGeoFilterDefaultModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  geoFilterName: string;
  isLoading?: boolean;
}

function GeoFilterDefaultModal({
  opened: isModalOpen,
  onClose: closeModal,
  onConfirm,
  geoFilterName,
  isLoading = false,
}: Readonly<IGeoFilterDefaultModalProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      description={geoFilterName}
      onClose={closeModal}
      opened={isModalOpen}
      rightActions={[
        <Button disabled={isLoading} key={'cancel'} onClick={closeModal}>
          {t('Cancel')}
        </Button>,
        <Button isLoading={isLoading} key={'confirm'} onClick={onConfirm} type={'primary'}>
          {t('Confirm')}
        </Button>,
      ]}
      title={t('Assign as default')}
    >
      <Alert title={t('Heads up!')} type={EAlertType.info}>
        {t(
          'Setting this geofilter set as the default only affects new campaigns. Existing campaigns will remain unchanged.',
        )}
      </Alert>
    </Modal>
  );
}

export default GeoFilterDefaultModal;
